import fracturedCore from './coreboundFracturedCore.svg';
import { getSectorJourney } from './sectorJourney';
import SectorSkyArt from './SectorSkyArt';
import './FracturedCoreBackdrop.css';

const fragments = [
  { x: 8, y: 19, size: 25, angle: -24, duration: 21 },
  { x: 91, y: 14, size: 18, angle: 38, duration: 26 },
  { x: 5, y: 54, size: 15, angle: 14, duration: 24 },
  { x: 94, y: 61, size: 29, angle: -42, duration: 22 },
  { x: 15, y: 81, size: 32, angle: 23, duration: 28 },
  { x: 83, y: 86, size: 21, angle: -18, duration: 25 },
  { x: 31, y: 92, size: 12, angle: 52, duration: 23 },
  { x: 70, y: 95, size: 16, angle: -32, duration: 29 },
];

const FracturedCoreBackdrop = ({ charge = 0, sector = 1 }) => {
  const journey = getSectorJourney(sector);
  return (
    <div
      className="coreboundFracturedCoreBackdrop"
      data-sector={journey.sector}
      style={{
        ...journey.style,
        '--corebound-core-charge': Math.min(1, Math.max(0, charge)),
      }}
      aria-hidden="true"
    >
      <div className="coreboundFracturedCoreHalo" />
      <SectorSkyArt sector={journey.sector} />
      {journey.sector === 10 && (
        <img
          className="coreboundFracturedCoreArt"
          src={fracturedCore}
          alt=""
          draggable="false"
        />
      )}
      <div className="coreboundFracturedCoreEnergy" />
      {[2, 3, 5, 9, 10].includes(journey.sector) &&
        fragments.map((fragment, index) => (
          <i
            key={index}
            className="coreboundFracturedCoreFragment"
            style={{
              left: `${fragment.x}%`,
              top: `${fragment.y}%`,
              width: `${fragment.size}px`,
              '--corebound-fragment-angle': `${fragment.angle}deg`,
              animationDuration: `${fragment.duration}s`,
              animationDelay: `${-index * 3.7}s`,
            }}
          />
        ))}
    </div>
  );
};

export default FracturedCoreBackdrop;
